import { useState } from "react";

const faqs = [
  {
    q: "AI美女生成需要什么技术基础吗？",
    a: "完全不需要！我们的AI美女生成平台专为普通用户设计，你只需要用文字描述你想要的形象即可。无论你是设计师还是完全没有美术基础的用户，都能轻松生成高质量的AI美女图像。",
  },
  {
    q: "生成的AI美女图像可以商用吗？",
    a: "是的，通过我们平台生成的AI美女图像均为原创虚拟形象，你可以自由用于个人和商业用途，包括社交媒体、广告宣传、产品设计等。不涉及真实人物肖像权问题。",
  },
  {
    q: "生成一张AI美女图像需要多长时间？",
    a: "通常情况下，从输入描述到生成图像只需5-15秒。具体的生成速度取决于图像的复杂度和当前服务器的负载情况。我们持续优化云端算力，确保最快的生成速度。",
  },
  {
    q: "支持哪些分辨率和格式？",
    a: "我们支持多种分辨率输出，包括适合社交头像的1:1比例、适合手机壁纸的9:16比例、以及适合电脑壁纸的16:9比例。输出格式为高质量PNG或JPEG。",
  },
  {
    q: "如何提高AI美女生成的质量？",
    a: "提高生成质量的关键在于写好提示词（描述文字）。建议描述越详细越好，包括人物特征、风格定位、场景设定、光线氛围等。你也可以参考我们教程中的提示词技巧，通过多次迭代获得最佳效果。",
  },
  {
    q: "平台支持哪些风格的AI美女？",
    a: "我们支持丰富的风格选择，包括但不限于：写真摄影风格、甜美可爱风格、高冷御姐风格、古典东方风格、现代时尚风格、梦幻唯美风格、赛博朋克风格等。你可以自由组合，创造独一无二的AI美女形象。",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4">
            常见问题
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            关于AI美女生成的问题
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            快速解答你关于AI美女创作的常见疑问。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.q}
                </span>
                <div
                  className={`w-6 h-6 flex-shrink-0 flex items-center justify-center transition-transform duration-300 text-foreground-400 ${
                    openIndex === idx ? "rotate-45" : ""
                  }`}
                >
                  <i className="ri-add-line text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? "max-h-96 pb-5" : "max-h-0"
                }`}
              >
                <p className="px-6 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}